<template>
  <div class="filter-container">
    <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="90px">
      <el-form-item label="索赔单号">
        <el-input
          v-model="searchForm.claimStatementId"
          placeholder="请输入索赔单号"
        ></el-input>
      </el-form-item>


      <el-form-item label="索赔单状态">
        <el-select v-model="searchForm.status" filterable clearable>
          <el-option
            label="全部"
            value="1,2,3,4,5,11,12,13,14,15,16,17,18,19,21"
          ></el-option>
          <el-option label="待预审" value="1"></el-option>
          <el-option label="驳回（预审）" value="2"></el-option>
          <el-option label="待正审" value="3"></el-option>
          <el-option label="驳回（正审）" value="4"></el-option>
          <el-option label="已拒赔" value="5"></el-option>
          <!-- <el-option label="待判责" value="6"></el-option>
          <el-option label="驳回（待判责）" value="7"></el-option> -->
          <!-- <el-option label="已判责" value="8"></el-option> -->
          <!-- <el-option label="驳回（已判责）" value="9"></el-option> -->
          <!-- <el-option label="未同意" value="10"></el-option> -->
          <el-option label="待确认（责任主体）" value="19"></el-option>
          <el-option label="驳回（责任确定）" value="21"></el-option>
          <el-option label="待结算" value="11"></el-option>
          <el-option label="已结算" value="12"></el-option>
          <el-option label="已取消" value="13"></el-option>
          <el-option label="已撤回" value="14"></el-option>
          <el-option label="待加签(部长)" value="15"></el-option>
          <el-option label="已驳回(部长)" value="16"></el-option>
          <el-option label="待加签(章总)" value="17"></el-option>
          <el-option label="已驳回(章总)" value="18"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二赔状态" v-if="secondStatus">
        <!-- :clearable="this.secondClaimStatus ? false : true" -->
        <el-select
          v-model="searchForm.secondClaimStatus"
          filterable
          clearable
        >
          <el-option
            v-for="(item, index) in secondStatusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户账号">
        <el-input
          v-model="searchForm.customerAccount"
          placeholder="请输入客户账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="销售订单号">
        <el-input v-model="searchForm.claimStatementNum" placeholder="请输入销售订单号"></el-input>
      </el-form-item>
      <el-form-item label="故障件件号">
        <el-input v-model="searchForm.faultPartNumber" placeholder="请输入故障件件号"></el-input>
      </el-form-item>
      <el-form-item label="故障件名称">
        <el-input v-model="searchForm.faultPartName" placeholder="请输入故障件名称"></el-input>
      </el-form-item>
      <el-form-item label="零部件专业">
        <el-select v-model="searchForm.lbjzy" filterable clearable placeholder="请选择零部件专业">
          <el-option
            v-for="(item, index) in partMajorList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算时间" v-if="secondStatus">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="settlementTime"
          type="daterange"
          align="right"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="setTimeSearch(5)"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="索赔类型">
        <el-select v-model="searchForm.claimType" filterable clearable placeholder="请选择索赔类型">
          <el-option
            v-for="(item, index) in splxList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开箱日期">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="openBoxDate"
          type="daterange"
          align="right"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="setTimeSearch(6)"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="申请时间">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="createTime"
          type="daterange"
          align="right"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="setTimeSearch(1)"
        >
        </el-date-picker>
      </el-form-item>
<!--      <el-form-item label="预审通过日期" v-if="!secondStatus">-->
<!--        <el-date-picker-->
<!--          value-format="yyyy-MM-dd"-->
<!--          v-model="preapprovalPassTime"-->
<!--          type="daterange"-->
<!--          align="right"-->
<!--          range-separator="-"-->
<!--          start-placeholder="开始日期"-->
<!--          end-placeholder="结束日期"-->
<!--          @change="setTimeSearch(2)"-->
<!--        >-->
<!--        </el-date-picker>-->
<!--      </el-form-item>-->

      <el-form-item label="正审时间" v-if="secondStatus">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="auditPassTime"
          type="daterange"
          align="right"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px"
          @change="setTimeSearch(3)"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="责任确定时间" v-if="secondStatus">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="confirmTime"
          type="daterange"
          align="right"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px"
          @change="setTimeSearch(4)"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="国家">
        <el-select
          filterable
          clearable
          v-model="searchForm.country"
          placeholder="请选择国家"
        >
          <el-option
            v-for="item in nationList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="供应商名称" v-if="secondStatus">
        <el-input v-model="searchForm.supplierName" placeholder="请输入供应商名称"></el-input>
      </el-form-item>
      
        <el-button
          type="primary"
          @click="handleSearch"
          >查询</el-button
        >
        <el-button type="primary" plain @click="handleResetQuery"
          >重置</el-button
        >
    
    </el-form>
  </div>
</template>
<script>
import { getSession } from "@/util/localStor";
export default {
  props: {
    recordsSearchObj: {
      type: Object,
      default: () => {}
    },
    carTypeList: {
      type: Array,
      default: () => {}
    },
    secondStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      secondStatusList: [
        { label: "待确认(金额)", value: "1" },
        { label: "已确认", value: "2" }
      ],
      splxList:[
        {
          name:'运输损坏',
          id:1
        },
        {
          name:'货差',
          id:2
        },
        {
          name:'质量问题',
          id:3
        },
        {
          name:'状态不符',
          id:4
        },
        {
          name:'其他',
          id:5
        },

      ],
      partMajorList:[
        {
          name:'车身',
          id:1
        },
        {
          name:'底盘',
          id:2
        },
        {
          name:'电器',
          id:3
        },
        {
          name:'内外饰',
          id:4
        },
        {
          name:'新能源',
          id:5
        },
        {
          name:'动力',
          id:6
        },
      ],//零部件专业
      searchForm: {
        secondClaimStatus: this.secondStatus?'1':'',
        openBoxDate:'',
        claimStatementId:'',
        customerAccount: "",
        claimStatementNum:'',
        faultPartName:"",
        faultPartNumber:"",
        lbjzy: "",
        claimType: "",
        createTime: "",
        preapprovalPassTime: "",
        country: "",
        status:this.secondStatus?'':'19',
        supplierName:''
      },
      openBoxDate:[],
      preapprovalPassTime:[],
      nationList: [],
      happenTime:[],
      confirmTime:[],
      settlementTime:[],
    auditPassTime:[],
      createTime:[]
    };
  },
  mounted() {
    this.searchForm = {
      ...this.searchForm,
      ...this.recordsSearchObj,
    };
    this.nationList = Object.values(getSession("nationList"));
    this.nationList[0].id=''
  },
  methods: {
    setTimeSearch(type){

      switch (type){
        case 1:

          this.searchForm.createTimeStart = this.createTime?this.createTime[0]:'';
          this.searchForm.createTimeEnd = this.createTime?this.createTime[1]:'';
          break;
        case 2:
          this.searchForm.preapprovalPassTimeStart = this.preapprovalPassTime?this.preapprovalPassTime[0]:'';
          this.searchForm.preapprovalPassTimeEnd = this.preapprovalPassTime?this.preapprovalPassTime[1]:'';
          break;
        case 3:
          this.searchForm.auditPassTimeStart = this.auditPassTime?this.auditPassTime[0]:'';
          this.searchForm.auditPassTimeEnd = this.auditPassTime?this.auditPassTime[1]:'';
          break;
        case 4:
          this.searchForm.confirmTimeStart = this.confirmTime?this.confirmTime[0]:'';
          this.searchForm.confirmTimeEnd = this.confirmTime?this.confirmTime[1]:'';
          break;
        case 5:
          this.searchForm.settlementTimeStart = this.settlementTime?this.settlementTime[0]:'';
          this.searchForm.settlementTimeEnd = this.settlementTime?this.settlementTime[1]:"";
          break;
        case 6:
          this.searchForm.openBoxDateStart = this.openBoxDate ? this.openBoxDate[0]:'';
          this.searchForm.openBoxDateEnd = this.openBoxDate?this.openBoxDate[1]:'';
          break;
      }
    },
    // 搜索
    handleSearch() {
      this.$emit("handleSearch", this.searchForm);
    },
    // 重置查询条件
    handleResetQuery() {
      this.searchForm = Object.assign({}, this.$options.data()?.searchForm);
      this.searchForm.secondClaimStatus=this.secondStatus?'1':'',
        this.searchForm.status=this.secondStatus?'':'19'
      this.createTime=[]
      this.preapprovalPassTime=[]
      this.auditPassTime=[]
      this.confirmTime=[]
      this.settlementTime=[]
      this.openBoxDate=[]
      this.handleSearch();
    }
  }
};
</script>
<!-- <style lang="scss" scoped>
.search {
  padding: 0 60px;
  margin-top: 15px;
  border-bottom: 5px solid #efefef;
  padding-right: 60px;
  ::v-deep .el-input {
    width: 200px;
  }
}
</style> -->
